<template>
    <div class="kanban-column"
         :class="{'is-compact': is_collapsed}"
         :style="{borderTopColor: color}">

        <div class="kanban-container">
            <div class="kanban-header">
                <i v-if="show_icon" class="header-icon fas fa-bars"></i> &nbsp;

                <div @click="toggle_column" class="header-title">
                    <i v-if="is_collapsed" class="fas fa-caret-right"></i>
                    {{column.name}}
                </div>

                <div class="action dropdown is-right"
                    :class="{'is-active': show_dropdown}"
                    @mouseleave="show_dropdown = false">

                    <i v-if="editable" @click="show_dropdown = !show_dropdown"
                       class="fas fa-ellipsis-v action"></i>

                    <div class="dropdown-menu">
                        <div class="dropdown-content">
                            <a @click="show_edit = true" class="dropdown-item">
                                <i class="fas fa-pen"></i> &nbsp; Edit
                            </a>

                            <a @click="show_confirm = true" class="dropdown-item">
                                <i class="fas fa-trash-alt"></i> &nbsp; Delete
                            </a>
                        </div>
                    </div>
                </div>

                <i @click="select_card_modal = true" class="fas fa-plus action"></i>
                <i @click="toggle_column" class="fas fa-caret-down action"></i>
            </div>

            <card-list
                :space="space"
                :flow="flow"
                :column="column"
                :search="search"
                :filter_tags="filter_tags"
                @select="$emit('select', arguments[0])"
                class="cards-list"/>
        </div>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this Column?"
            @close="show_confirm = false"
            @ok="remove_column"/>

        <column-update
            v-if="show_edit"
            @close="show_edit = false"
            :column="column"
            :space="space"
            :flow="flow"/>

        <select-note-modal
            v-if="select_card_modal"
            :space="space"
            :flow="flow"
            :column="column"
            @create="open_create_modal"
            @close="select_card_modal = false"/>

        <create-card-modal
            v-if="create_card_modal"
            :space="space"
            :flow="flow"
            :column="column"
            @close="create_card_modal = false"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ColumnUpdate from './ColumnUpdate.vue';
import SelectNoteModal from './SelectNoteModal.vue';
import CardList from './CardList.vue';
import CreateCardModal from './CreateCardModal.vue';

export default {
    name: 'Column',
    props: {
        color: { type: String, default: '#5cb85c' },
        show_icon: { type: Boolean, default: true },
        editable: { type: Boolean, default: true },
        search: { type: String, default: '' },
        filter_tags: { type: Array },
        column: { type: Object },
        space: { type: Object },
        flow: { type: Object },
    },
    components: {
        CardList,
        ColumnUpdate,
        CreateCardModal,
        SelectNoteModal,
    },
    computed: {
        ...mapState('cards', ['create']),
        ...mapState('columns', ['collapsed_columns']),
        is_collapsed() {
            const columns = this.collapsed_columns[this.flow.id];
            return columns && columns.includes(this.column.id);
        },
    },
    data() {
        return {
            show_dropdown: false,
            show_confirm: false,
            select_card_modal: false,
            create_card_modal: false,
            show_edit: false,
        };
    },
    methods: {
        toggle_column() {
            this.$store.commit('columns/toggle_column', {
                column_id: this.column.id,
                flow_id: this.flow.id,
            });
        },
        async remove_column() {
            await this.$store.dispatch('columns/remove', {
                column_id: this.column.id,
                space_id: this.space.id,
                flow_id: this.flow.id,
            });

            await this.$store.dispatch('columns/list', {
                space_id: this.space.id,
                flow_id: this.flow.id,
            });
        },
        open_create_modal() {
            this.select_card_modal = false;
            this.create_card_modal = true;
        },
    },
};
</script>

<style scoped>
    .kanban-column {
        height: 100%;
        float: left;
        margin-left: 1.3rem;
        border: 1px solid #e5e5e5;
        background: #fafafa;
        border-radius: 0.3rem;
        border-top: 3px solid;
    }

    .kanban-container {
        width: 25rem;
        height: 100%;
    }

    .kanban-header {
        padding: 0.8rem 1.2rem;
        border-bottom: 1px solid #e5e5e5;
    }

    .header-title {
        display: inline;
    }

    .action {
        float: right;
        color: gray;
        cursor: pointer;
        margin-left: 0.5rem;
    }

    .action:hover {
        color: #000000;
    }

    .is-compact {
        width: 3.3rem;
    }

    .is-compact .kanban-header {
        border: none;
    }

    .is-compact .cards-list,
    .is-compact .action,
    .is-compact .header-icon {
        display: none;
    }

    .is-compact .header-title {
        -webkit-writing-mode: tb-rl;
        -ms-writing-mode: tb-rl;
        writing-mode: tb-rl;
        margin: 0 0 0 -1rem;
        cursor: pointer;
    }
</style>
Теперь писать на русском языке одно удовольстьвие
